import React from "react";
import { Button, Typography, Space } from "antd";
import { WarningOutlined, LogoutOutlined } from "@ant-design/icons";
import { logout } from "../services/authService";

const { Title, Text } = Typography;

const PendingApprovalOverlay = () => {
  const handleLogout = async () => {
    try {
      await logout();
      // Clear session storage directly to ensure logout works
      sessionStorage.clear();
      // Force navigation to sign-in page
      window.location.href = "/sign-in";
    } catch (error) {
      console.error("Logout error:", error);
      // Force logout even if API call fails
      sessionStorage.clear();
      window.location.href = "/sign-in";
    }
  };

  return (
    <>
      {/* Main content overlay that allows clicks to pass through */}
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backdropFilter: "blur(4px)",
          backgroundColor: "rgba(0, 0, 0, 0.4)",
          zIndex: 998,
          pointerEvents: "none", // This makes clicks pass through to underlying elements
        }}
      />

      {/* Central modal with pointer events enabled */}
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          zIndex: 999,
          pointerEvents: "none", // This makes clicks pass through by default
        }}
      >
        <div
          style={{
            background: "white",
            padding: "40px",
            borderRadius: "12px",
            textAlign: "center",
            maxWidth: "500px",
            boxShadow: "0 8px 24px rgba(0, 0, 0, 0.2)",
            animation: "fadeIn 0.5s ease-out",
            pointerEvents: "auto", // Only the modal itself captures clicks
          }}
        >
          <Space direction="vertical" size="large" style={{ width: "100%" }}>
            <div>
              <WarningOutlined
                style={{
                  fontSize: "60px",
                  color: "#faad14",
                  padding: "16px",
                  backgroundColor: "#fffbe6",
                  borderRadius: "50%",
                  marginBottom: "16px",
                  border: "2px solid #ffe58f",
                }}
              />
            </div>

            <Title level={3} style={{ margin: 0, color: "#262626" }}>
              Account Pending Approval
            </Title>

            <div style={{ padding: "0 20px" }}>
              <Text
                style={{
                  fontSize: "16px",
                  color: "#595959",
                  lineHeight: "1.6",
                }}
              >
                Your account is awaiting approval from a Super Admin.
                <br />
                You can explore and navigate through the dashboard while you
                wait.
                <br />
                <Text strong style={{ color: "#262626" }}>
                  Full access will be granted once your account is approved.
                </Text>
              </Text>
            </div>

            <Button
              type="primary"
              size="large"
              icon={<LogoutOutlined />}
              onClick={handleLogout}
              style={{
                marginTop: "10px",
                height: "46px",
                borderRadius: "6px",
                fontWeight: "500",
                width: "180px",
              }}
            >
              Logout
            </Button>
          </Space>
        </div>
      </div>

      <style>
        {`
          @keyframes fadeIn {
            from { opacity: 0; transform: translateY(-20px); }
            to { opacity: 1; transform: translateY(0); }
          }
        `}
      </style>
    </>
  );
};

export default PendingApprovalOverlay;
